import type { SVGProps } from 'react';
const SvgDownCarrot = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <rect
        width={30}
        height={30}
        x={1}
        y={1}
        stroke="#E2E8F0"
        strokeWidth={2}
        rx={15}
      />
      <path d="M24 16a40 40 0 0 0-.352-5.196 2.81 2.81 0 0 0-2.452-2.452A40 40 0 0 0 16 8c-1.952 0-3.752.161-5.196.352a2.81 2.81 0 0 0-2.452 2.452A40 40 0 0 0 8 16c0 1.952.161 3.752.352 5.196a2.81 2.81 0 0 0 2.452 2.452C12.248 23.84 14.048 24 16 24s3.752-.161 5.196-.352a2.81 2.81 0 0 0 2.452-2.452C23.84 19.752 24 17.952 24 16m1.631-5.458a4.81 4.81 0 0 0-4.173-4.173C19.948 6.169 18.058 6 16 6s-3.948.17-5.458.369a4.81 4.81 0 0 0-4.173 4.173C6.169 12.052 6 13.942 6 16s.17 3.948.369 5.458a4.81 4.81 0 0 0 4.173 4.173c1.51.2 3.4.369 5.458.369s3.948-.17 5.458-.369a4.81 4.81 0 0 0 4.173-4.173c.2-1.51.369-3.4.369-5.458s-.17-3.948-.369-5.458" />
      <path
        fill="#777E90"
        d="M20.207 13.793a1 1 0 0 0-1.414 0L16 16.586l-2.793-2.793a1 1 0 0 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414"
      />
    </g>
  </svg>
);
export default SvgDownCarrot;
